import moment from "moment";

export function filterActiveNotices(list: any[] = []) {
  return list.filter((notice: any) => {
    const hasStart = !!notice?.startTime;
    const hasEnd = !!notice?.endTime;
    if (notice?.status !== 1) {
      return false;
    }
    if (!hasStart) {
      return true;
    }
    if (hasStart && !hasEnd) {
      return moment().isAfter(notice.startTime);
    }
    return moment().isAfter(notice.startTime) && moment().isBefore(notice.endTime);
  });
}

export function getNoticeHideUntilKey(scope = "default") {
  return `notice-hide-until:${scope}`;
}

export function isNoticeHiddenByScope(scope = "default") {
  if (!process.client) {
    return false;
  }
  const rawValue = window.localStorage.getItem(getNoticeHideUntilKey(scope));
  const timestamp = rawValue ? Number(rawValue) : 0;
  return Number.isFinite(timestamp) && timestamp > Date.now();
}

export function hideNoticeByDays(scope = "default", days = 3) {
  if (!process.client) {
    return;
  }
  const hideUntil = Date.now() + days * 24 * 60 * 60 * 1000;
  window.localStorage.setItem(getNoticeHideUntilKey(scope), String(hideUntil));
}
